import { render, staticRenderFns } from "./index.vue?vue&type=template&id=299fa061&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../../styles/table.less?vue&type=style&index=0&id=299fa061&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299fa061",
  null
  
)

export default component.exports